// FILECONTENT_START src/common/components/DataGrid/row-buttons/ActionButtonView.tsx
import VisibilityIcon from "@mui/icons-material/Visibility";
import I18n from "i18n-js";
import { Link } from "react-router-dom";
import { DataGridActionButtonProps } from "../DataGrid";
import { GridActionsCellItem } from "../grid-imports";

export default function ActionButtonView({
  to,
  onClick,
  disabled,
}: DataGridActionButtonProps) {
  if (to) {
    return (
      <GridActionsCellItem
        icon={<VisibilityIcon />}
        label={I18n.t("App.view")}
        title={I18n.t("App.view")}
        //@ts-ignore
        to={to}
        component={Link}
        disabled={disabled}
        //color="inherit"
      />
    );
  }
  return (
    <GridActionsCellItem
      icon={<VisibilityIcon />}
      label={I18n.t("App.view")}
      title={I18n.t("App.view")}
      onClick={onClick ? () => onClick() : undefined}
      disabled={disabled}
      //color="inherit"
    />
  );
}

// FILECONTENT_END src/common/components/DataGrid/row-buttons/ActionButtonView.tsx